/* eslint-disable @typescript-eslint/no-explicit-any */
import { FilterLeadFormValues } from 'app/pages/MapPage/type';
import axios from 'axios';
import * as qs from 'qs';
import { formatPayload } from 'utils/index';
import { TFile, TNote } from 'types/user';

export type CreateLeadPayload = {
  fileId: number;
  type: string;
  address: string;
  flag: boolean;
  city: string;
  province: string;
  phoneNumber: string;
  information: string;
  ruleOut: boolean;
  earlyMorning: boolean;
  doorKnock: boolean;
  isRegisterBC: boolean;
  notes?: {
    id?: number;
    content?: string;
    isDelete?: boolean;
    notePhotosIds?: number[];
    updatedAt?: string;
  }[];
};

export interface Lead {
  id: number;
  type: string;
  address: string;
  flag: boolean;
  city: string;
  province: string;
  longitude: number;
  latitude: number;
  phoneNumber: string;
  information: any;
  ruleOut: boolean;
  note: any;
  fileId: string;
  earlyMorning: any;
  doorKnock: any;
  createdAt: string;
  updatedAt: string;
  colour: string;
  plate: string;
  deletedAt: any;
  file: Files;
  remindLeads: { id: string }[];
  leadTowYards: {
    id: string;
    content: string;
    userId: string;
    checked: boolean;
    user?: {
      role: string;
    };
  }[];
  leadDocuments: {
    id: string;
    storageId: string;
    url: string;
    name: string;
  }[];
  notes: TNote[];
  isAdmin?: boolean;
}

export type Files = TFile;

export const getLead = async (payload: FilterLeadFormValues) => {
  const { data: res } = await axios.get('/leads', { params: formatPayload(payload) });
  return res;
};

type GetLeadsParams = {
  size: number;
  page: number;
  earlyMorning: boolean;
  doorKnock: boolean;
  status: string[];
  types: string[];
  category: string;
};

export type payloadLoadCreateReport = {
  fileId: number;
  kilometers: number;
  hasKey: boolean;
  addressLeadId?: number;
  otherAddress?: string;
  customersLeadId?: number;
  otherCustomerPOR?: string;
  run: boolean;
  signedVsa: boolean;
  possibleRedemption: boolean;
  transportRequired: boolean;
  billsIncurred: boolean;
  conditionReport: string;
  towingCompany: string;
  vsaDocumentIds: number[];
  seizureReportPhotoIds: number[];
  removedToId?: number;
  removedToOther?: string;
  otherBills?: string;
  hiddenCommunication?: boolean;
  otherTransport?: string;
};

export const createLead = async (payload: Partial<CreateLeadPayload>) => {
  const { data: res } = await axios.post('/leads', payload);
  return res;
};
export const updateLead = async (id: number, payload: Partial<CreateLeadPayload>) => {
  const { data: res } = await axios.put(`/leads/${id}`, payload);
  return res;
};
export const deleteNote = (id: number) => axios.delete(`/notes/${id}`);
export const deleteLead = async (id: number) => {
  await axios.delete(`/admin/leads/${id}`);
};

export const getLeads = async (params: Partial<GetLeadsParams>) => {
  const payload = formatPayload({
    ...params,
    types: params.types,
    status: params.status,
    category: params.category
  });
  const query = qs.stringify(payload);
  const { data } = await axios.get(`/leads?${query}`);
  return data;
};

export const getLeadsAllMap = async (params: Partial<GetLeadsParams>) => {
  const payload = formatPayload({
    ...params,
    types: params.types,
    status: params.status,
    category: params.category
  });
  const query = qs.stringify(payload);
  const { data } = await axios.get(`/leads/map-all?${query}`);
  return data;
};

export const createSeizureReport = async (payload: Partial<payloadLoadCreateReport>) => {
  const { data: res } = await axios.post(`/seizure-reports`, payload);
  return res;
};
